import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {ConfigProvider} from 'antd';
import AppLocale from '../../../shared/localization';
import {useLayoutContext} from '../AppContextProvider/LayoutContextProvider';
import {useLocaleContext} from '../AppContextProvider/LocaleContextProvide';

const AppThemeProvider = (props: any) => {
  const {direction}: any = useLayoutContext();
  const {locale}: any = useLocaleContext();

  const {antLocale} = AppLocale[locale.code.toLowerCase()];

  useEffect(() => {
    document.body.setAttribute('dir', direction);
  }, [direction]);

  return (
    <ConfigProvider
      direction={direction}
      locale={antLocale}
      theme={{
        token: {
          colorPrimary: '#ea5383',
          colorLink: '#ea5383',
          fontFamily: "'Quicksand', sans-serif",
          fontWeightStrong: 500,
          borderRadius: 10,
          controlHeight: 40,
        },
        components: {
          Button: { borderRadius: 10 },
          Input: { borderRadius: 10 },
          Select: { borderRadius: 10 },
          DatePicker: { borderRadius: 10 },
          Modal: { borderRadius: 10 },
          Card: { borderRadius: 16 },
        },
      }}
    >
      {props.children}
    </ConfigProvider>
  );
};

export default React.memo(AppThemeProvider);

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
